import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';

const GridItem = (props) => {
  const { children, ...others } = props;
  return <Grid {...others}>{children}</Grid>;
};

export default GridItem;
